(function () {
  "use strict";

  var root = document.querySelector(".blog-post, .blog-page");
  if (!root) return;
  var content = root.querySelector(".post-content");
  if (!content) return;

  function labelScrollRegion(element, label) {
    if (!element.hasAttribute("tabindex")) element.setAttribute("tabindex", "0");
    if (!element.hasAttribute("role")) element.setAttribute("role", "region");
    if (!element.hasAttribute("aria-label") && !element.hasAttribute("aria-labelledby")) {
      element.setAttribute("aria-label", label);
    }
  }

  content.querySelectorAll("table").forEach(function (table) {
    // Keep third-party embeds and nested tables under their existing owner.
    if (table.closest(".gist, .kg-embed-card") || table.parentElement.closest("table")) return;
    var wrapper = table.closest(".table-wrapper, .scroll-x");
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.className = "table-wrapper";
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
    labelScrollRegion(wrapper, root.dataset.tableLabel || "Scrollable table");
  });

  content.querySelectorAll("pre").forEach(function (block) {
    if (block.closest(".gist, .kg-embed-card")) return;
    labelScrollRegion(block, root.dataset.codeLabel || "Scrollable code");
  });

  content.querySelectorAll(".kg-button-card a.kg-btn").forEach(function (link) {
    // An author's explicit appearance is part of the article, not the theme.
    if (link.hasAttribute("style") || link.classList.contains("stcs-button")) return;
    link.classList.remove("kg-btn", "kg-btn-accent");
    link.classList.add("stcs-button");
    link.dataset.variant = "primary";
    link.dataset.size = "medium";
    var label = document.createElement("span");
    label.className = "stcs-button__label";
    while (link.firstChild) label.appendChild(link.firstChild);
    var buttonContent = document.createElement("span");
    buttonContent.className = "stcs-button__content";
    buttonContent.appendChild(label);
    link.appendChild(buttonContent);
  });
})();
